<template>
  <a-breadcrumb class="m-breadcrumb-container">
    <a-breadcrumb-item
      v-for="item in breadList"
      :key="item.id"
      class="common-bread-item"
      :class="{ 'common-bread-item-hover': item.menuUrl && item.menuUrl != $route.path }"
      @click.native="item.menuUrl && item.menuUrl != $route.path && handleClick(item)">
      <!-- <a-icon
        v-if="breadList[breadList.length -2] && breadList[breadList.length -2].menuUrl"
        @click.prevent="handleLink(breadList[breadList.length -2].menuUrl)"
        type="left"
        class="m-icon-hover"
      /> -->
      <span v-if="currentBreadList && item.menuUrl == $route.path">{{ currentBreadList }}</span>
      <span v-else>{{ item.name }}</span>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
import { mapState } from "vuex"
import { event, store } from "@ice/stark-data"
import { getSession } from "@/utils/storage"
export default {
  name: "Breadcrumb",
  props: {
    menu: {
      type: Array
    }
  },
  computed: {
    ...mapState(["subMenu", "activeMenu"])
    // ...mapState(['subMenu', 'activeMenu', 'currentPath'])
  },
  components: {},
  data() {
    return {
      breadList: [],
      currentBreadList: "",
      currentPath: ""
    }
  },
  watch: {
    $route(to, from) {
      this.currentPath = getSession("currentPath")
      this.breadList = this.setMenu(this.menu, to.path)
      this.currentBreadList = ""
      if (to.path.includes("undefined")) {
        event.emit("currentBread", "")
        window.history.pushState({}, "", this.currentPath)
      }
    }
  },
  mounted() {
    this.bulletBreadcrumbData()
    const { path } = this.$route
    this.breadList = this.setMenu(this.menu, path)
  },
  methods: {
    handleClick(item) {
      if (item.menuUrl) {
        // 判断是否是 costCenter 子应用（根据你的菜单 URL 或应用标识来区分）
        if (item.menuUrl.startsWith("/costCenter")) {
          // 方案 A：只针对 costCenter 走事件通知，触发子应用的 router.push
          event.emit("microAppNavigate", item.menuUrl)
        } else {
          // 其他子应用保持原样，走原本的 history.pushState 逻辑
          window.history.pushState({}, "", item.menuUrl)

          // 如果其他子应用也需要通知主应用路由改变，可按需补充主应用的路由同步逻辑
        }
      }
    },
    //根据某一个节点向上匹配所有父节点数据
    setMenu(tree, url) {
      var path = []
      if (!tree) return []
      var forFn = function (tree, url) {
        for (var i = 0; i < tree.length; i++) {
          // 存放最后返回的内容
          var data = tree[i]
          if (data.menuType != 2) {
            path.push(data)
          }
          if (data?.menuUrl === url) return path
          if (data.children) {
            const findChildren = forFn(data.children, url)
            if (findChildren) return findChildren
          }
          path.pop()
        }
      }
      forFn(tree, url)
      return path
    },
    async bulletBreadcrumbData() {
      await event.on("currentBread", this.getBread)
    },
    getBread(value) {
      this.currentBreadList = value
    },
    handleLink(item) {
      // 特殊处理下面包屑的返回事件，由于有些页面点击时需要弹窗让用户二次确认
      if (event.has("breadCrumb")) {
        event.emit("breadCrumb")
      } else {
        this.$router.back()
      }
      //  window.history.pushState({}, '', item)
    }
  }
}
</script>

<style lang="less" scoped>
#container {
  .m-breadcrumb-container {
    .common-bread-item > span,
    .common-bread-item > span > span {
      color: #8c8c8c !important;
    }
    .common-bread-item:last-of-type > span > span {
      color: #262626 !important;
    }
    .common-bread-item-hover {
      cursor: pointer;
    }
  }
}

.jinmao-breadcrumb {
  font-size: 16px;
  font-weight: 500;
  color: #999999;
  // margin-top: 60px;
  // margin-left: 226px;
  a {
    color: #999999;
  }
  .jinmao-breadcrumb-separator {
    color: #999999;
  }
  > span:last-child {
    color: #333333;
  }
}
.business-breadcrumb-link {
  display: flex;
  align-items: center;
}
i.m-icon-hover.anticon.anticon-left {
  background: transparent;
}
.m-icon-hover {
  width: 24px;
  padding: 5px 0;
  border-radius: 2px;
}
.m-icon-hover:hover {
  background: #f5f5f5;
}
</style>
